module.exports = __webpack_public_path__ + "img/artnhealing_main_03.0ca2eb51.jpg";